import React, { createContext, useContext, useState, useEffect } from 'react';
import { injectTokenGetter } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Page load hone par sessionStorage se initial values padhein
  const [token, setToken] = useState(() => {
    return sessionStorage.getItem('access_token') || null;
  });

  const [user, setUser] = useState(() => {
    const savedUser = sessionStorage.getItem('user_data');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  // Axios Interceptor ko updated token dynamic pass karne ke liye
  useEffect(() => {
    injectTokenGetter(() => token);
  }, [token]);

  // Login handler: Memory + sessionStorage dono update karega
  const login = (accessToken, userData) => {
    setToken(accessToken);
    setUser(userData);
    sessionStorage.setItem('access_token', accessToken);
    sessionStorage.setItem('user_data', JSON.stringify(userData));
  };

  // Logout handler: Storage aur Memory dono wipe karega
  const logout = () => {
    setToken(null);
    setUser(null);
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('user_data');
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        user,
        isAuthenticated: !!token,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);